import React from 'react'
import Sections from 'components/Order/sections'
import styles from './AttatchmentForm.module.css'
import { FormColumn } from 'components/Shared/CrudComponents'
import { AttachmentsDropzone } from 'components/Order/OrderForms/OrderForm/AttachmentForm/AttachmentsDropzone'
import { attachmentTypes } from 'components/Order/constants'
import { useFormikContext } from 'formik'
import { uploadAttachment } from 'services/OrderService'
import {
  ORDER_ATTACHMENTS_CARGO_PHOTOS_READ,
  ORDER_ATTACHMENTS_CONFIRMATION_READ,
  ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_READ,
  ORDER_ATTACHMENTS_OTHER_DOCUMENTS_READ,
  useAuth
} from 'context/auth'

const handleAttachmentsUpdate = (updatedFiles, setFieldValue, values, type) => {
  const allUpdatedFiles = values.attachments.filter(file => file.type !== type)
    .concat(updatedFiles.map(f => ({ ...f, type })))
  setFieldValue('attachments', allUpdatedFiles)
}

const handleAttachmentRemoved = (deletedFile, setFieldValue, values) => {
  const deletedFiles = [...(values.deletedAttachmentsIds || []), deletedFile.id]
  setFieldValue('deletedAttachmentsIds', deletedFiles)
}

export function AttachmentForm ({ initialAttachments }) {
  const { setFieldValue, values } = useFormikContext()
  const { hasAnyPrivileges } = useAuth()

  return <FormColumn section={Sections.Attachments}
                     className={styles.dropdownSection}
                     visible={hasAnyPrivileges([
                       ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_READ,
                       ORDER_ATTACHMENTS_CARGO_PHOTOS_READ,
                       ORDER_ATTACHMENTS_OTHER_DOCUMENTS_READ,
                       ORDER_ATTACHMENTS_CONFIRMATION_READ])}>
    <>
      {attachmentTypes
        .filter(type => hasAnyPrivileges([type.requiredPrivilege.read]))
        .map(type =>
          <AttachmentsDropzone key={type.value}
                               initialAttachments={initialAttachments?.filter(att => att.type === type.value)}
                               onAttachmentsUpdated={(updated) => handleAttachmentsUpdate(updated, setFieldValue, values, type.value)}
                               onAttachmentRemoved={(deletedFile) => handleAttachmentRemoved(deletedFile, setFieldValue, values)}
                               label={`form.order.attachments.${type.label}`}
                               type={type.value}
                               disabled={!hasAnyPrivileges([type.requiredPrivilege.write])}
                               dropzoneStyles={styles.attachmentLabel}
                               uploadAttachment={file => uploadAttachment(file, type.value)}
                               chipContainerStyles={styles.attachmentChipContainer}/>)
      }
    </>
  </FormColumn>
}
